export const REMINDER_OPTIONS = [
  {
    label: "Не відправляти",
    value: 0,
  },
  {
    label: "За 1 годину до візиту",
    value: 1,
  },
  {
    label: "За 2 годину до візиту",
    value: 2,
  },
  {
    label: "За 3 годину до візиту",
    value: 3,
  },
  {
    label: "За 4 годину до візиту",
    value: 4,
  },
  {
    label: "За 5 годин до візиту",
    value: 5,
  },
  {
    label: "За 6 годин до візиту",
    value: 6,
  },
  {
    label: "За 9 годин до візиту",
    value: 9,
  },
  {
    label: "За 12 годин до візиту",
    value: 12,
  },
  {
    label: "За 15 годин до візиту",
    value: 15,
  },
  {
    label: "За 18 годин до візиту",
    value: 18,
  },
  {
    label: "За 21 годину до візиту",
    value: 21,
  },
  {
    label: "За 24 години до візиту",
    value: 24,
  },
  {
    label: "За 48 годин до візиту",
    value: 48,
  },
  {
    label: "За 72 години до візиту",
    value: 72,
  },
  {
    label: "За 120 годин до візиту",
    value: 120,
  },
  {
    label: "За 168 годин до візиту",
    value: 168,
  },
];
